export const environment = {
    production: true,
    apiUrl: 'https://tgnv12.smartworkar.com:8888',
    frontUrl: '',
    urlAssets: 'http://localhost:4200',
    //urlBack: 'http://localhost:8083',
    urlBack: 'https://tgn-emyr-back.candoit.com.ar',
    user: {
        username: "tgntesting@vreadynow.com",
        password: "larealidadesvirtual"
    },
    userApi: {
        username: "a",
        password: "a"
    },
    protocolName: ''


};